import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import en from './en.json';

/**
 * i18n config:
 *   - English bundled at startup (above)
 *   - hi/ta/kn fetched lazily from /locales/{lng}/translation.json
 *   - LanguageDetector picks from localStorage → navigator → fallback en
 *   - User can override via Settings → Language
 */
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi', 'ta', 'kn'],
    ns: ['translation'],
    defaultNS: 'translation',
    resources: { en: { translation: en } },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'snt:lang',
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
